// Base
import { BaseApi } from 'api/base.api';

// Interface
import {
  IAssessmentPreparationCommentApi,
  IAssessmentPreparationCommentApiRequest,
  IAssessmentPreparationCommentApiGetListAttrs,
  IAssessmentPreparationCommentApiUpdateAttrs,
  IAssessmentPreparationCommentApiListResponse,
  IAssessmentPreparationCommentApiNullResponse,
  IAssessmentPreparationCommentApiUpdateManyAttrs,
} from 'interfaces/back-office/assessment/preparation/comment/comment-api.interface';

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant';

// Utils
import { axios_renderHcUrl } from 'utils';

export class AssessmentPreparationCommentApi
  extends BaseApi<IAssessmentPreparationCommentApi>
  implements IAssessmentPreparationCommentApiRequest
{
  readonly url = ApiConstantHc.ASSESSMENT_PREPARATION_COMMENT_URL;
  private assessmentPreparationCommentUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT);

  /**
   * @description Get assessment preparation comment list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentPreparationCommentApiGetListAttrs} payload
   *
   * @return {Promise<IAssessmentPreparationCommentApiListResponse>} Promise<IAssessmentPreparationCommentApiListResponse>
   */
  async assessmentPreparationComment_getList(
    payload: IAssessmentPreparationCommentApiGetListAttrs,
  ): Promise<IAssessmentPreparationCommentApiListResponse> {
    return this.POST(
      `${this.assessmentPreparationCommentUrl}/list/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    );
  }

  /**
   * @description Update assessment preparation comment
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentPreparationCommentApiUpdateAttrs} payload
   *
   * @return {Promise<IAssessmentPreparationCommentApiNullResponse>} Promise<IAssessmentPreparationCommentApiNullResponse>
   */
  async assessmentPreparationComment_update(
    payload: IAssessmentPreparationCommentApiUpdateAttrs,
  ): Promise<IAssessmentPreparationCommentApiNullResponse> {
    return this.POST(`${this.assessmentPreparationCommentUrl}/update/${payload.params.commentId}`, payload.body, {
      ...payload.requestConfig,
    });
  }
  /**
   * @description Update many assessment preparation comment
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentPreparationCommentApiUpdateManyAttrs} payload
   *
   * @return {Promise<IAssessmentPreparationCommentApiNullResponse>} Promise<IAssessmentPreparationCommentApiNullResponse>
   */
  async assessmentPreparationComment_update_many(
    payload: IAssessmentPreparationCommentApiUpdateManyAttrs,
  ): Promise<IAssessmentPreparationCommentApiNullResponse> {
    return this.POST(`${this.assessmentPreparationCommentUrl}/updateMany`, payload.body, {
      ...payload.requestConfig,
    });
  }
}
